import type { SubPractices } from "../config.types";

import { intakeConfirmationScreens } from "./common-immigration";

export const immigrationElse: SubPractices = {
  firstScreen: "service-type",
  screens: {
    "service-type": {
      next: async ({ answers, experiments }) => {
        const { serviceType } = answers;
        const { abTestImmigrationEligibility } = experiments;
        if (!abTestImmigrationEligibility) {
          return "applicant-type";
        }

        if (serviceType === "else") {
          return "case-urgency";
        }

        if (serviceType === "Tourist visa") {
          return "tourist-visa-status";
        }

        return "visa-eligibility";
      },
    },
    "tourist-visa-status": {
      next: async () => "case-urgency",
    },
    "visa-eligibility": {
      next: async ({ answers }) => {
        const { serviceType, visaEligibility } = answers;

        const studentInScope =
          serviceType === "Student visa" &&
          visaEligibility === "I’ve been accepted to school in the U.S.";

        const employmentInScope =
          serviceType === "Employment visa" &&
          visaEligibility === "I have a job offer from a U.S. employer";

        const investorInScope =
          serviceType === "Investor visa" &&
          [
            "I have an investment in the U.S.",
            "I’m considering a few investment options",
          ].includes(visaEligibility!);

        const isInScope =
          studentInScope || employmentInScope || investorInScope;

        return isInScope ? "case-urgency" : "out-of-scope";
      },
    },
    "applicant-type": {
      next: async () => "case-urgency",
    },
    "case-urgency": {
      next: async ({ experiments }) => {
        const { abTestImmigrationEligibility } = experiments;
        return abTestImmigrationEligibility ? "more-info" : "funding-source";
      },
    },
    "funding-source": {
      next: async () => "beneficiary-region",
    },
    "beneficiary-region": {
      next: async () => "more-info",
    },

    ...intakeConfirmationScreens,

    "out-of-scope": {
      next: async () => undefined,
    },
  },
};
